import {ApiComm} from "../comm";
import { BookInfoDTO, SearchBookInfoDTO } from "../dto/BookDTOs";
//import {UserAccessTokenDto, UserInfoDTO } from "../dto/UserDTOs";
import {ResponseDTO} from "../dto/ResponseDTO";
import {genNoobookHeader} from "./Common";
import { NoobookFileInfoDTO } from "../dto/CommonDTOs";
import _ from "lodash";



export function searchBooksByKeyword(authToken:string, keyword:string, page:number, size:number):Promise<ResponseDTO<SearchBookInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<SearchBookInfoDTO[]>>('/close/v1/book/search'
        , {keyword:keyword, page:page, size:size}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function getBookByIsbn(authToken:string, isbn:string):Promise<ResponseDTO<SearchBookInfoDTO>>
{
    return ApiComm.getData<ResponseDTO<SearchBookInfoDTO>>(`/close/v1/book/search/isbn/${isbn}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function getBookByBookId(authToken:string, bookId:number):Promise<ResponseDTO<BookInfoDTO>>
{
    return ApiComm.getData<ResponseDTO<BookInfoDTO>>(`/close/v1/book/${bookId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}



export function searchEditableBooks(authToken:string, title:string, author:string, publisher:string, isbn:string, page:number, size:number):Promise<ResponseDTO<BookInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookInfoDTO[]>>('/close/v1/book/editable/search'
        , {title:title, author:author, publisher:publisher, isbn:isbn, page:page, size:size}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function uploadBookImageToTmpFile(authToken:string, file:File):Promise<ResponseDTO<NoobookFileInfoDTO>>
{
    return ApiComm.postFormData<ResponseDTO<NoobookFileInfoDTO>>(`/close/v1/book/editable/image`
        , {file:file}
        , genNoobookHeader(authToken, null, 'multipart/form-data', "app")
    ).then(resp=>resp.data);
}


export function createEditableBooks(authToken:string, title:string, author:string, publisher:string
    , isbn:string, isbn13:string, category:string, imgTmpFileId:string, pageNum:number, publishedAt:Date):Promise<ResponseDTO<BookInfoDTO[]>>
{
    return ApiComm.postData<ResponseDTO<BookInfoDTO[]>>('/close/v1/book/editable'
        , {title:title, author:author, publisher:publisher, isbn:isbn, isbn13:isbn13
            , category:category, imgTmpFileId:imgTmpFileId, pageNum:pageNum, publishedAt:publishedAt}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function modifyEditableBooks(authToken:string, bookId:number, title:string, author:string, publisher:string
    , isbn:string, isbn13:string, category:string, imgTmpFileId:string, pageNum:number, publishedAt:Date):Promise<ResponseDTO<BookInfoDTO[]>>
{
    return ApiComm.putData<ResponseDTO<BookInfoDTO[]>>(`/close/v1/book/${bookId}/editable`
        , {title:title, author:author, publisher:publisher, isbn:isbn, isbn13:isbn13
            , category:category, imgTmpFileId:imgTmpFileId, pageNum:pageNum, publishedAt:publishedAt}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}



/*
export const memoizedInstallerUsers = _.memoize(async (authToken)=>{
    return await ApiComm.getData<IMASResponseDto<TaskWorker[]>>('admin/fms/v1/user/installer', {},genNoobookHeader(authToken)).then(resp=>resp.data);
});
*/

